import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EvBorcKontrolAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "EvBorcKontrol";
        super(baseUrl);
    }
    getEvBorcKontrol(SqId: number, Durum: number) {
        var request = new EvBorcKontrolRequest(SqId, Durum);

        return this.post("", request, false);
    }
}

export default new EvBorcKontrolAPI();
class EvBorcKontrolRequest {
    public sqId: number;
    public durum: number;

    constructor(sqId: number, durum: number) {

        this.sqId = sqId;
        this.durum = durum;

    }
}
export { EvBorcKontrolRequest };


